(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const overlay = $('[data-overlay]');
  const closeDrawers = () => {
    $$('.drawer').forEach((drawer) => drawer.classList.remove('open'));
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  };
  const openDrawer = (drawer) => {
    closeDrawers();
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', () => openDrawer($('[data-cart-drawer]'))));
  $$('[data-menu-open]').forEach((button) => button.addEventListener('click', () => openDrawer($('[data-menu-drawer]'))));
  $$('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawers));
  if (overlay) overlay.addEventListener('click', closeDrawers);

  $$('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('.gallery');
    const main = $('[data-gallery-main]', gallery);
    if (main) main.src = button.dataset.src;
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => thumb.classList.remove('active'));
    button.classList.add('active');
  }));

  $$('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = $('[data-qty]', button.closest('.quantity'));
    input.value = Math.max(1, Number(input.value) - 1);
  }));
  $$('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = $('[data-qty]', button.closest('.quantity'));
    input.value = Number(input.value) + 1;
  }));

  $$('[data-product-form]').forEach((form) => {
    const variantSelect = $('[data-variant-select]', form);
    const optionSelects = $$('[data-option-index]', form);
    const price = $('[data-product-price]', form.closest('.product-info'));
    optionSelects.forEach((select) => select.addEventListener('change', () => {
      const selected = optionSelects.map((item) => item.value).join('||');
      const option = $$('option', variantSelect).find((item) => item.dataset.options === selected && !item.disabled);
      if (option) {
        variantSelect.value = option.value;
        if (price) price.textContent = option.dataset.price;
      }
    }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = $('button[type="submit"]', form);
      const label = $('[data-add-label]', form);
      submit.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantSelect.value), quantity: Number($('[data-qty]', form).value) }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
        $$('[data-cart-count]').forEach((counter) => counter.textContent = cart.item_count);
        const content = $('[data-cart-content]');
        if (cart.item_count > 0) {
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const itemsHtml = cart.items.map((item) => {
    const imageUrl = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
    const imageHtml = item.image
      ? '<div><img src="' + imageUrl + '" width="90" height="90" style="width:90px;height:90px;object-fit:cover;display:block;border-radius:8px" loading="lazy" alt="' + item.product_title + '"></div>'
      : '';
    const variantHtml = item.variant_title ? item.variant_title + ' · ' : '';
    return '<div class="cart-item">' + imageHtml + '<p><b>' + item.product_title + '</b><span>' + variantHtml + 'Qty ' + item.quantity + '</span><strong>' + money(item.final_line_price) + '</strong></p></div>';
  }).join('');
  content.innerHTML = itemsHtml + '<div class="cart-total"><span>Subtotal</span><b>' + money(cart.total_price) + '</b></div><a class="add checkout" href="' + window.Shopify.routes.root + 'cart">View cart & checkout ↗</a>';
} else {
  content.innerHTML = '<div class="empty"><span>◇</span><p>Your bag needs a little sparkle.</p><a class="primary" href="' + window.Shopify.routes.root + 'collections/all">Shop the kit</a></div>';
}
        openDrawer($('[data-cart-drawer]'));
      } catch (error) {
        alert(error.message);
      } finally {
        submit.disabled = false;
        if (label) label.textContent = 'Add to bag';
      }
    });
  });
})();
